import React from 'react'
import Dte from 'src/localization/Dte'
import { UserListModel, UserListResponse } from 'src/models/user.models'
import {
  ExpenseCategoryLabelResponse,
  ExpenseCategoryResponse,
} from 'src/queries/organizations/expenseCategories.queries'

export enum AutomationRuleStatusType {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE', // TODO check this
}

export enum AutomationRuleObjectType {
  CreditCard = 'CREDIT_CARD',
  VirtualCard = 'VIRTUAL_CARD',
  Transaction = 'TRANSACTION',
  Department = 'DEPARTMENT',
}

export enum AutomationRuleFundingSource {
  VirtualCard = 'VIRTUAL_CARD',
  CreditCard = 'CREDIT_CARD',
}

export enum AutomationComparator {
  Equals = 'EQUALS',
  Contains = 'CONTAINS',
}

export interface AutomationRuleCondition {
  objectType: AutomationRuleObjectType
  objectFieldName: string
  comparator: AutomationComparator
  targetValue: string
  group: number
}

export enum AutomationRuleListDiscriminatorType {
  VirtualCard = 'VIRTUAL_CARD',
  CreditCard = 'CREDIT_CARD',
}

type AutomationRuleResponse = {
  id: string
  createdAt: string
  name: string
  status: AutomationRuleStatusType
  conditions: AutomationRuleConditionResponse[]
  mappings: AutomationRuleMappingResponse[]
}

export interface AutomationRuleConditionResponse {
  id: string
  ruleId: string
  objectType: AutomationRuleObjectType
  objectFieldName: string
  comparator: AutomationComparator
  targetValue: string
  group: number
  source?: AutomationRuleSource
}

export interface AutomationRuleMappingResponse {
  id: string
  ruleId: string
  expenseCategory: ExpenseCategoryResponse
  expenseLabel?: ExpenseCategoryLabelResponse
}

export interface AutomationRuleSource {
  source: AutomationRuleListDiscriminatorType
  sourceId: string
  displayName: string
  last4?: string
}

export type AutomationRuleDetailResponse = AutomationRuleResponse

export class AutomationRuleDetailModel {
  public id: string
  public createdAt: string
  public name: string
  public status: AutomationRuleStatusType
  public conditions: AutomationRuleConditionResponse[]
  public mappings: AutomationRuleMappingResponse[]

  public constructor(data: AutomationRuleDetailResponse) {
    this.id = data.id
    this.createdAt = data.createdAt
    this.name = data.name
    this.status = data.status
    this.conditions = data.conditions
    this.mappings = data.mappings
  }
}

export type AutomationRuleListResponse = AutomationRuleResponse & {
  createdByUser: UserListResponse
}

export class AutomationRuleListModel {
  public id: string
  public createdAt: string
  public name: string
  public status: AutomationRuleStatusType
  public conditions: AutomationRuleConditionResponse[]
  public mappings: AutomationRuleMappingResponse[]
  public createdByUser: UserListModel

  public constructor(data: AutomationRuleListResponse) {
    this.id = data.id
    this.createdAt = data.createdAt
    this.name = data.name
    this.status = data.status
    this.conditions = data.conditions
    this.mappings = data.mappings
    this.createdByUser = new UserListModel(data.createdByUser)
  }

  public get createdAtString(): React.ReactElement {
    return <Dte date={this.createdAt} format={'l'} />
  }
}
